import { render, staticRenderFns } from "./ingreso.vue?vue&type=template&id=51789dd3&scoped=true"
import script from "./ingreso.vue?vue&type=script&lang=js"
export * from "./ingreso.vue?vue&type=script&lang=js"
import style0 from "./ingreso.vue?vue&type=style&index=0&id=51789dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51789dd3",
  null
  
)

export default component.exports